import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { optionalUrlParams } from 'utils/common';
import { SimpleDropDown, SimpleDropDownElement } from 'components/simple-dropdown';
import { useTranslation } from 'react-i18next';
import { SORTING_KEYS } from 'utils/enums';
import { urlSortSelector } from 'common/selectors/router';
import { withRatingSelector, withPlaysSelector } from '../../common/selectors';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

const Component = withRouter(
  connect(
    (state, props) => ({
      sort: urlSortSelector(state, props.match),
      withRating: withRatingSelector(state),
      withPlays: withPlaysSelector(state),
    }),
    false
  )((props) => {
    const { t } = useTranslation();
    return (
      <div className="ct-sorting">
        <SimpleDropDown
          title={t(SORTING_KEYS[props.sort ? props.sort : 'display_date'])}
          className="ct-sorting__dropdown-title"
          data-e2e="sorting-dropdown-button"
          left={true}
          iconRight={faCaretDown}
          aria-label={t('sorting-menu')}
        >
          {props.sortBy
            .filter((item) => {
              if (
                (item === SORTING_KEYS.rating && !props.withRating) ||
                (item === SORTING_KEYS.plays && !props.withPlays)
              ) {
                return false;
              }
              return props.sort ? item !== props.sort : item !== SORTING_KEYS.display_date;
            })
            .map((item) => (
              <SimpleDropDownElement
                key={item}
                linkTo={props.link + optionalUrlParams({ sort: item })}
                data-e2e={`sort-by-${item}`}
              >
                {t(item)}
              </SimpleDropDownElement>
            ))}
        </SimpleDropDown>
      </div>
    );
  })
);

export const Sorting = ({
  sortBy = [SORTING_KEYS.display_date, SORTING_KEYS.plays, SORTING_KEYS.title_asc],
  link,
  videoId,
}) => <Component sortBy={sortBy} link={link} videoId={videoId} />;

Sorting.propTypes = {
  sortBy: PropTypes.array.isRequired,
  link: PropTypes.string.isRequired,
  videoId: PropTypes.string,
};
